/**
 * ポップアップバナー
 */
export default class PopupBanner extends HTMLElement {

  constructor() {
    super();

    // ストーレージ用のKey
    const POPUP_SESSION_KEY = 'popupSessionKey';
    const POPUP_LAST_CLOSED_DATE = 'popupLastClosedDate';
    const POPUP_CLOSE_COUNT = 'popupCloseCount';

    // 閉じる回数の上限
    const CLOSE_MAX_COUNT = 2;

    // 現在の日付を "YYYY-MM-DD" フォーマットで取得
    const today = new Date().toISOString().split('T')[0];

    // Local Storage から前回記録された日付とクローズ回数を取得
    let lastClosedDate = localStorage.getItem(POPUP_LAST_CLOSED_DATE);
    let closeCount = parseInt(localStorage.getItem(POPUP_CLOSE_COUNT) || '0', 10);

    // 日付が変わっていた場合、クローズ回数をリセット
    if (lastClosedDate !== today) {
      closeCount = 0; // クローズ回数をリセット
      localStorage.setItem(POPUP_CLOSE_COUNT, '0'); // 保存
      localStorage.setItem(POPUP_LAST_CLOSED_DATE, today); // 本日の日付を記録
    }

    // セッション内でポップアップがすでに閉じられていれば非表示のまま
    if (sessionStorage.getItem(POPUP_SESSION_KEY)) {
      return;
    }

    // 当日中のクローズ回数が最大値未満の場合のみポップアップを表示
    if (closeCount < CLOSE_MAX_COUNT) {
      this.classList.remove("unico-u-hidden");
    }

    const closeButton = this.querySelector(".unico-popup-banner-close-button");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.classList.add("unico-u-hidden");

        // セッション内で非表示にしたことを記録
        sessionStorage.setItem(POPUP_SESSION_KEY, 'true');

        // 当日中のクローズ回数を計測
        closeCount++;
        localStorage.setItem(POPUP_CLOSE_COUNT, closeCount); // 更新
      });
    }
  }
}
